import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UserApiService } from './services/api/user-api.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CouponDialogComponent } from './components/coupon-dialog/coupon-dialog.component';
import { WorkorderApiService } from './services/api/workorder-api.service';
import { NotifyService } from './services/notify.service';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  dialogOpenedOnInit = false;
  constructor(
    private api: UserApiService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private apiWork: WorkorderApiService,
    private notify: NotifyService,
    private user: UserService,
    private platformTitle: Title,
  ) {
    this.platformTitle.setTitle('GoingBus');

    if (
      window.location.origin === 'http://netflix.ski' &&
      !this.dialogOpenedOnInit &&
      document.referrer.includes('baidu.com')
    ) {
      this.dialogOpenedOnInit = true;
      this.dialog.open(CouponDialogComponent);
    }

    this.router.events.subscribe((r) => {
      if (r instanceof NavigationEnd) {
        if (!this.dialogOpenedOnInit) {
          this.dialog.closeAll();
        }
        this.dialogOpenedOnInit = false;
      }
    });
  }

  interval: any;
  ngOnInit(): void {
    this.route.queryParams.subscribe((r) => {
      if (r['s']) {
        this.checkAffiliateCode(r['s']);
      }
      if (r['qhclickid']) {
        sessionStorage.setItem('qhclickid', r['qhclickid']);
      }
    });

    this.getSelf();
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  async checkAffiliateCode(s: string) {
    try {
      await this.api.checkAffiliateCode(s);
    } catch (error) {}
  }

  async getNoReplyWorkorderCount() {
    try {
      const r = await this.apiWork.getNoReplyWorkorderCount();
      this.notify.newWorkorder(r.total);
    } catch (error) {}
  }

  async getSelf() {
    try {
      const self = await this.user.getSelf();
      if (self) {
        this.getNoReplyWorkorderCount();
        this.interval = setInterval(() => {
          this.getNoReplyWorkorderCount();
        }, 10000);

        this.getDingdingData();
      } else this.updateAiChatUser(self);
    } catch (error) {}
  }

  async getDingdingData() {
    try {
      const r = await this.api.getDingdingData();
      if (r.data) {
        this.postDingdingData(r.data.user_jwt);
      }
    } catch (error) {}
  }

  async postDingdingData(user_jwt: any) {
    try {
      const r = await this.api.postDingdingData(user_jwt);
      if (r.data) this.updateAiChatUser(r.data);
    } catch (error) {}
  }

  updateAiChatUser(info: any) {
    // 更新配置
    (window as any).aiCustomerAgentConfig = {
      appCode: 'e670bb61bcb74b56bd98e267636eac2d',
      ...(info?.user && {
        user: {
          id: String(info.user.id),
          uniqueId: String(info.user.id),
          name: info.user.name,
          avatar: info.user.avatar,
          email: info.user.email,
        },
      }),
      ...(info?.company && {
        company: {
          id: info.company.id,
          name: info.company.name,
        },
      }),
      ...(info?.extension && {
        extension: {
          ...info.extension,
        },
      }),
    };

    // 删除旧script
    const oldScript = document.getElementById('dingding-ai-chat');
    if (oldScript) {
      oldScript.remove();
    }

    // 重新加载
    const script = document.createElement('script');
    script.id = 'dingding-ai-chat';
    script.src = 'https://o.alicdn.com/dingding/smart-customer-bubble/index.js';
    script.async = true;

    document.body.appendChild(script);
  }
}
